import { AxiosError } from 'axios';
import { useState } from 'react';
import { useAxios } from './useAxios';
import { UseApiProps, UseApiObjectProps, BaseApiResponse } from './useApi.types';

export const useApi: UseApiProps = <ResponseDTO>(hookParams?: UseApiObjectProps<ResponseDTO>) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<AxiosError>();
  const [data, setData] = useState<ResponseDTO | undefined>();
  const { get, post } = useAxios();

  const handleResponse = (axiosResponseData: BaseApiResponse<ResponseDTO>) => {
    const { data, isSuccess } = axiosResponseData;

    if (isSuccess) setData(data);

    if (isSuccess && !!hookParams?.onComplete) {
      hookParams.onComplete(data);
    }
  };

  const handleError = (error: AxiosError) => {
    setError(error);

    if (!!hookParams?.onError) {
      hookParams.onError(error);
    }
  };

  const getRequest = <T>(url: string, params?: T) => {
    setLoading(true);
    get<BaseApiResponse<ResponseDTO>>(url, params)
      .then(axiosResponse => {
        handleResponse(axiosResponse.data);
      })
      .catch(err => {
        handleError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const postRequest = <T>(url: string, data?: T) => {
    setLoading(true);
    post<BaseApiResponse<ResponseDTO>>(url, data, hookParams?.requestConfig)
      .then(axiosResponse => {
        handleResponse(axiosResponse.data);
      })
      .catch(err => {
        handleError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return [
    { getRequest, postRequest },
    { loading, data, error },
  ];
};
